import { computed, ComputedRef } from 'vue'
import { useStore } from 'vuex'

import { ProblemStateModuleName } from '@/store/modules/modules'

export class ProblemStateViewModel {
  private store = useStore()

  problemId: ComputedRef<string> = computed(() => this.store.getters[`${ProblemStateModuleName}/problemId`])
  nextProblemId: ComputedRef<string> = computed(() => this.store.getters[`${ProblemStateModuleName}/nextProblemId`])
  prevProblemId: ComputedRef<string> = computed(() => this.store.getters[`${ProblemStateModuleName}/prevProblemId`])

  setProblemId(problemId: string): void {
    this.store.commit(`${ProblemStateModuleName}/setProblemId`, problemId)
  }

  setNextProblemId(nextProblemId: string): void {
    this.store.commit(`${ProblemStateModuleName}/setNextProblemId`, nextProblemId)
  }

  setPrevProblemId(prevProblemId: string): void {
    this.store.commit(`${ProblemStateModuleName}/setPrevProblemId`, prevProblemId)
  }
}
